module.exports = __webpack_public_path__ + "img/49_2.08a30b14.png";